import { BrowserRouter, Routes } from 'react-router-dom';
import './App.scss';
import Footer from './components/Footer';
import Header from './components/Header';
import GalleryPage from './pages/GalleryPage';
import MainPage from './pages/MainPage';
import ScrollToHashElement from './hooks/ScrollToHashElement';
import { Route } from 'react-router-dom';
import CommitteePage from './pages/CommitteePage';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true, }}>
      <div className="App">
        <ScrollToHashElement />

        <Header />

        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/committee" element={<CommitteePage />} />
        </Routes>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
